import { Component, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild, AfterViewInit } from '@angular/core';
import { MakeProvider } from '../abstract-custom-control';
import { Router } from '@angular/router';
import { BaseDataService } from '../../base-services/base-data.service';
import { FormGroup, FormControl, Validators, ValidationErrors } from '@angular/forms';
import { EmailExistenceValidator } from '../../validators/email-existence-validator';
import { CheckPassword } from './register.component';
import { InputComponent } from '../input/input/input.component';
import { ReCaptchaV3Service } from 'ng-recaptcha';

const _USER_REGISTRATION_THANK_YOU_PAGE = 'https://minibiz.rs/otvoren-mini-nalog/';

@Component({
    selector: 'yt-register-v2',
    templateUrl: './register-v2.component.html',
    providers: [MakeProvider(RegisterV2Component)],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegisterV2Component implements AfterViewInit{
    constructor(
        private router: Router,
        private baseDataService: BaseDataService,
        private changeDetectionRef: ChangeDetectorRef,
        private recaptchaV3Service: ReCaptchaV3Service
    ){
    }

    registerFormGroup: FormGroup = new FormGroup({
        FirstName: new FormControl('', Validators.required),
        LastName: new FormControl('', Validators.required),
        // City: new FormControl(null, Validators.required),
        Phone: new FormControl(''),
        Email: new FormControl('', [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')], EmailExistenceValidator.createValidator(this.baseDataService)),
        Password: new FormControl('', [Validators.required, Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&\.]).{8,}')]),
        PasswordConfirm: new FormControl('', Validators.required),
        TermsAccepted: new FormControl(false, Validators.requiredTrue)
    },
        { validators: CheckPasswordV2})

    registerSubmitted: boolean = false;
    registering: boolean = false;
    showStatus: boolean = false;
    statusText: string = '';
    capsLockMessage: string;

    @ViewChild('firstName', { static: true }) firstName: InputComponent;
    @ViewChild('password', { static: true }) password: InputComponent;

    ngAfterViewInit(){
        setTimeout(() => {
            if(this.firstName){
                this.firstName.focus();
            }
        }, 100);

        const eventHandler = (event: KeyboardEvent | MouseEvent) => {
            if(event.type === 'keyup' && !(event instanceof KeyboardEvent)){
                return;
            }
            if(event.getModifierState('CapsLock')){
                this.capsLockMessage = 'CAPS-LOCK-ON';
            }
            else{
                this.capsLockMessage = undefined;
            }
            this.changeDetectionRef.markForCheck();
        };

        this.password.inputControl.nativeElement.addEventListener('keyup', eventHandler);
        this.password.inputControl.nativeElement.addEventListener('mousedown', eventHandler);
    }

    ngOnDestroy(){
        this.password.inputControl.nativeElement.removeAllListeners('keyup');
        this.password.inputControl.nativeElement.removeAllListeners('mousedown');
    }

Register(firstName, lastName, phone, email, password, passwordConfirm) {
  this.registerSubmitted = true;
  this.registerFormGroup.updateValueAndValidity();

  if (this.registerFormGroup.valid && !this.registerFormGroup.pending) {
    this.registering = true;
    this.recaptchaV3Service.execute('register').subscribe(token => {
      const termsAccepted = this.registerFormGroup.get('TermsAccepted')!.value === true;

      const parameters = {
        FirstName: firstName,
        LastName: lastName,
        Email: email,
        Password: password,
        Phone: phone,
        TermsAccepted: termsAccepted,
        RecaptchaToken: token
      };

      this.baseDataService.GetData('registration', 'register', parameters).subscribe(
        _ => { this.router.navigate(['/korisnicki-nalog-kreiran']); window.open(_USER_REGISTRATION_THANK_YOU_PAGE, '_blank'); },
        _ => { this.registering = false; this.changeDetectionRef.detectChanges(); }
      );
    });
  }
}
}

export function CheckPasswordV2(group: FormGroup): ValidationErrors {
    if(!group || !group.get('Password') || !group.get('PasswordConfirm')){
        return null;
    }

    let password = group.get('Password').value;
    let confirmPassword = group.get('PasswordConfirm').value;
    return password === confirmPassword ? null : { notSame: true };
}